<template>
  <div>
    <section
      v-if="!import_file"
      class="m-0">
      <section-title
        :title="$t('message.chosefilexlsx')"
        fontweight="bold"/>
      <div class="file has-name is-fullwidth">
        <label class="file-label">
          <input
            ref="input_file"
            class="file-input"
            type="file"
            @change="handleFileUpload">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"/>
            </span>
            <span class="file-label">
              {{ $t('message.choosefile') }}
            </span>
          </span>
          <span class="file-name">
            <span
              v-if="!import_file_name"
              class="text-grey">{{ $t('message.nofilechosen') }}</span>
            <span v-else>{{ import_file_name }}</span>
          </span>
        </label>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div
            v-if="!import_file_error"
            class="row">
            <!-- section -->
            <div class="col-12 mt-2">
              <p class="mb-1">
                <b>{{ $t('message.note') }}</b>
              </p>
              <p class="m-0">
                {{ $t('message.noteimportexcelfile') }}
              </p>
            </div>
          </div>
          <div
            v-else
            class="row">
            <div class="col-12">
              <span class="text-danger">
                {{ $t('message.pleasechosexlsxfile') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      v-else
      class="m-0"
    >
      <section-title
        :title="$t('message.fieldref')"
        fontweight="bold"
      />
      <div class="row mb-3">
        <div class="col-12">
          <vs-radio
            v-model="refBy"
            :disabled="getImportProductCount > 0"
            color="#A3CA76"
            vsValue="product_name"
            style="float: left;padding: 0;margin-right: 50px;"
          >
            <strong>
              {{ $t('message.productname') }}
            </strong>
          </vs-radio>
          <vs-radio
            v-model="refBy"
            :disabled="getImportProductCount > 0"
            color="#A3CA76"
            vsValue="sku"
            style="float: left;padding: 0;margin-right: 50px;"
          >
            <strong>
              {{ $t('message.sku') }}
            </strong>
          </vs-radio>
          <vs-radio
            v-model="refBy"
            :disabled="getImportProductCount > 0"
            color="#A3CA76"
            vsValue="barcode"
            style="float: left;padding: 0;"
          >
            <strong>
              {{ $t('message.barcode') }}
            </strong>
          </vs-radio>
        </div>
      </div>

      <section-title
        :title="$t('message.importproductlists')"
        fontweight="bold"/>
      <div class="row">
        <div
          v-if="isInvalidCount > 0"
          class="col-12 mt-2 mb-1">
          <p
            v-if="isInvalidNameCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproducttitlenotfoundcount', {number: isInvalidNameCount})"/>
          </p>
          <p
            v-if="isInvalidTitleCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproducttitleinvalidcount', {number: isInvalidTitleCount})"/>
          </p>
          <p
            v-if="isInvalidPriceCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproductpriceinvalidcount', {number: isInvalidPriceCount})"/>
          </p>
          <p
            v-if="isInvalidCostCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproductcostinvalidcount', {number: isInvalidCostCount})"/>
          </p>
          <p
            v-if="isInvalidBarcodeCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproductbarcodenotfoundcount', {number: isInvalidBarcodeCount})"/>
          </p>
          <p
            v-if="isInvalidSkuCount > 0"
            class="text-danger mb-2">
            <span v-html="$t('message.importproductskunotfoundcount', {number: isInvalidSkuCount})"/>
          </p>
        </div>

        <div class="col-12 wrapper-table">
          <table class="table table-bordered m-0">
            <thead>
              <tr>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="refBy !== 'product_name' && !isRefColumnSelected"
                      class="btn no-bg text-secondary title"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('title');">
                      {{ $t('message.productname') }}
                      <template v-if="refBy === 'product_name'">
                        *
                      </template>
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                        <i
                          v-if="refBy === 'product_name' && !isRefColumnSelected"
                          class="far fa-hand-point-down text-warning vert-move"
                        />
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="this.import_data_table.title.length == 0">
                          <label>
                            {{ $t('message.choseyourcolumn', {string: $t('message.productname')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.title = []; selected_column_index = ''; closeDropDownTitle()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="!isRefColumnSelected"
                      class="btn no-bg text-secondary prices"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('prices');">
                      {{ $t('message.price') }}
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.prices.length == 0">
                          <label>
                            {{ $t('message.choseyourcolumn', {string: $t('message.price')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.prices = []; selected_column_index = ''; closeDropDownPrices()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="!isRefColumnSelected"
                      class="btn no-bg text-secondary costs"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('costs');">
                      {{ $t('message.cost') }}
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.costs.length == 0">
                          <label>
                            {{ $t('message.choseyourcolumn', {string: $t('message.cost')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.costs = []; selected_column_index = ''; closeDropDownCosts()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="!isRefColumnSelected"
                      class="btn no-bg text-secondary categories"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('categories');">
                      {{ $t('message.category') }}
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.categories.length == 0">
                          <label>
                            {{ $t('message.choseyourcolumn', {string: $t('message.category')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.categories = []; selected_column_index = ''; closeDropDownCategories()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="refBy !== 'sku' && !isRefColumnSelected"
                      class="btn no-bg text-secondary skus"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('skus');">
                      {{ $t('message.sku') }}
                      <template v-if="refBy === 'sku'">
                        *
                      </template>
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                        <i
                          v-if="refBy === 'sku' && !isRefColumnSelected"
                          class="far fa-hand-point-down text-warning vert-move"
                        />
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.skus.length == 0">
                          <label>
                            {{ $t('message.sku', {string: $t('message.sku')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.skus = []; selected_column_index = ''; closeDropDownSkus()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="refBy !== 'barcode' && !isRefColumnSelected"
                      class="btn no-bg text-secondary barcodes"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('barcodes');">
                      {{ $t('message.barcode') }}
                      <template v-if="refBy === 'barcode'">
                        *
                      </template>
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                        <i
                          v-if="refBy === 'barcode' && !isRefColumnSelected"
                          class="far fa-hand-point-down text-warning vert-move"
                        />
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.barcodes.length == 0">
                          <label>
                            {{ $t('message.choseyourcolumn', {string: $t('message.barcode')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.barcodes = []; selected_column_index = ''; closeDropDownBarcodes()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown item">
                    <button
                      :disabled="!isRefColumnSelected"
                      class="btn no-bg text-secondary units"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      @click="handleHeadColumnClick('units');">
                      {{ $t('message.unit') }}
                      <span class="icon-import">
                        <i class="far fa-arrow-alt-circle-down"/>
                      </span>
                    </button>
                    <div class="dropdown-menu">
                      <form
                        class="px-3 py-2"
                        style="min-width: 300px;">
                        <template v-if="import_data_table.units.length == 0">
                          <label>
                            {{ $t('message.unit', {string: $t('message.unit')}) }}
                          </label>
                          <select
                            v-model="selected_column_index"
                            class="form-control custom-select">
                            <option value="">{{ $t('placeholder.select') }}</option>
                            <option
                              v-for="(value, index) in this.import_data_column"
                              :value="index">
                              {{ value }}
                            </option>
                          </select>
                        </template>
                        <button
                          v-else
                          type="button"
                          class="btn btn-light btn-sm btn-block"
                          @click="import_data_table.units = []; selected_column_index = ''; closeDropDownUnits()">
                          {{ $t('message.unselectedcolumn') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-if="getImportProductCount == 0">
                <td
                  colspan="9"
                  class="text-center not-found">
                  {{ $t('message.noteimportproducts') }}
                </td>
              </tr>
              <tr
                v-for="(item, index) in getMaxRows"
                v-if="getImportProductCount > 0"
                style="height: 35px;">
                <td
                  :class="[
                    {
                      'is-invalid': (
                        !isValidName(import_data_table.title[index])
                        && refBy === 'product_name'
                      )
                    }
                  ]"
                >
                  <span v-if="import_data_table.title.length > 0">
                    {{ import_data_table.title[index] }}
                  </span>
                  <vs-tooltip
                    v-if="!isValidName(import_data_table.title[index])"
                    :text="$t('message.fieldnotfound')"
                    position="top">-</vs-tooltip>
                </td>
                <td
                  :class="[{'is-invalid': !isValidNumber(import_data_table.prices[index])}]"
                >
                  <span v-if="import_data_table.prices.length > 0">
                    {{ formatNumberFloat (import_data_table.prices[index]) }}
                  </span>
                  <vs-tooltip
                    :text="$t('message.numberonly')"
                    position="top">-</vs-tooltip>
                </td>
                <td
                  :class="[{'is-invalid': !isValidNumber(import_data_table.costs[index])}]"
                >
                  <span v-if="import_data_table.costs.length > 0">
                    {{ formatNumberFloat (import_data_table.costs[index]) }}
                  </span>
                  <vs-tooltip
                    :text="$t('message.numberonly')"
                    position="top">-</vs-tooltip>
                </td>
                <td>
                  <span v-if="import_data_table.categories.length > 0">
                    {{ import_data_table.categories[index] }}
                  </span>
                </td>
                <td
                  :class="[
                    {
                      'is-invalid': (
                        !isValidSKU(import_data_table.skus[index])
                        && refBy === 'sku'
                      )
                    }
                  ]"
                >
                  <span v-if="import_data_table.skus.length > 0">
                    {{ import_data_table.skus[index] }}
                  </span>
                  <vs-tooltip
                    :text="$t('message.fieldnotfound')"
                    position="top">-</vs-tooltip>
                </td>
                <td
                  :class="[
                    {
                      'is-invalid': (
                        !isValidBarcode(import_data_table.barcodes[index])
                        && refBy === 'barcode'
                      )
                    }
                  ]"
                >
                  <span v-if="import_data_table.barcodes.length > 0">
                    {{ import_data_table.barcodes[index] }}
                  </span>
                  <vs-tooltip
                    :text="$t('message.fieldnotfound')"
                    position="top">-</vs-tooltip>
                </td>
                <td>
                  <span v-if="import_data_table.units.length > 0">
                    {{ import_data_table.units[index] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="getImportProductCount > 0"
        class="row mt-3">
        <div class="col-12">
          <p class="m-0">
            {{ $t('message.importproductcount', {number: getImportProductCount}) }}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  props: [],
  data () {
    return {
      refBy: 'product_name',
      import_file: null,
      import_file_error: false,
      import_file_name: '',
      import_data_column: [],
      import_data_rows: [],
      import_data_table: {
        title: [],
        prices: [],
        costs: [],
        categories: [],
        skus: [],
        units: [],
        warehouses: [],
        images: [],
        barcodes: [],
        instocks: [],
      },
      selected_column_index: '',
      selected_column_indexs: [],
      selected_column_ref: '',
      point_column_at_index: {
        title: '',
        prices: '',
        costs: '',
        categories: '',
        skus: '',
        units: '',
        warehouses: '',
        images: '',
        barcodes: '',
        instocks: '',
      },
      isValidData: false,
      isInvalidCount: 0,
      isInvalidNameCount: 0,
      isInvalidTitleCount: 0,
      isInvalidPriceCount: 0,
      isInvalidCostCount: 0,
      isInvalidBarcodeCount: 0,
      isInvalidSkuCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      dateformat: 'getDateFormat',
      allSkuCode: 'getAllSkuCode',
      getNames: 'getNames',
      getBarcodes: 'getBarcodes',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
    }),
    getRefBy() {
      const patt = {
        'product_name': 'title',
        'sku': 'skus',
        'barcode': 'barcodes',
      }
      return patt[this.refBy]
    },
    isRefColumnSelected() {
      return this.import_data_table[this.getRefBy].length > 0
    },
    warehousesShortNameList () {
      return this.warehouses.map((item) => item.short_name)
    },
    getMaxRows () {
      var max = 0
      if (this.import_file) {
        this.import_data_table.title.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.prices.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.costs.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.categories.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.skus.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.units.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
        this.import_data_table.barcodes.map((val, index) => {
          let _index = index + 1
          if (_index > max) max = _index
        })
      }

      return max
    },
    getImportProductCount () {
      var count = 0
      this.import_data_table[this.getRefBy].map((val, index) => {
        count++
      })
      return count
    },
    getImportProducts () {
      var products = []

      this.import_data_table[this.getRefBy].map((value, index) => {
        if (value) {
          var product = {
            'product_name': this.import_data_table.title[index] != null
              ? `${this.import_data_table.title[index]}`
              : undefined,
            'price': undefined,
            'cost': undefined,
            'unit': undefined,
            'barcode': undefined,
            'sku': undefined,
            'category_name': undefined,
          }

          if (this.import_data_table.prices[index] != null) {
            product['price'] = this.import_data_table.prices[index]
          }

          if (this.import_data_table.costs[index] != null) {
            product['cost'] = this.import_data_table.costs[index]
          }

          if (this.import_data_table.units[index] != null) {
            product['unit'] = this.import_data_table.units[index].toString()
          }

          if (this.import_data_table.barcodes[index] != null) {
            product['barcode'] = this.import_data_table.barcodes[index].toString()
          }

          if (this.import_data_table.skus[index] != null) {
            product['sku'] = this.import_data_table.skus[index].toString()
          }

          if (this.import_data_table.categories[index] != null) {
            product['category_name'] = this.import_data_table.categories[index]
          }

          products.push(product)
        }
      })

      return products
    },
  },
  watch: {
    selected_column_index: function (after, before) {
      let column_index = this.selected_column_index

      if (column_index !== '') {
        switch (this.selected_column_ref) {
          case 'title':
            this.import_data_table.title = []
            this.point_column_at_index.title = column_index
            this.closeDropDownTitle()
            break
          case 'prices':
            this.import_data_table.prices = []
            this.point_column_at_index.prices = column_index
            this.closeDropDownPrices()
            break
          case 'costs':
            this.import_data_table.costs = []
            this.point_column_at_index.costs = column_index
            this.closeDropDownCosts()
            break
          case 'categories':
            this.import_data_table.categories = []
            this.point_column_at_index.categories = column_index
            this.closeDropDownCategories()
            break
          case 'images':
            this.import_data_table.images = []
            this.point_column_at_index.images = column_index
            this.closeDropDownImages()
            break
          case 'barcodes':
            this.import_data_table.barcodes = []
            this.point_column_at_index.barcodes = column_index
            this.closeDropDownBarcodes()
            break
          case 'instocks':
            this.import_data_table.instocks = []
            this.point_column_at_index.instocks = column_index
            this.closeDropDownInStocks()
            break
          case 'warehouses':
            this.import_data_table.warehouses = []
            this.point_column_at_index.warehouses = column_index
            this.closeDropDownWarehouses()
            break
          case 'units':
            this.import_data_table.units = []
            this.point_column_at_index.units = column_index
            this.closeDropDownUnits()
            break
          case 'skus':
            this.import_data_table.skus = []
            this.point_column_at_index.skus = column_index
            this.closeDropDownSkus()
            break
        }

        this.import_data_rows.map((row, index) => {
          row.map((column, _index) => {
            if (column_index == _index) {
              switch (this.selected_column_ref) {
                case 'title':
                  this.import_data_table.title.push(column)
                  break
                case 'prices':
                  this.import_data_table.prices.push(column)
                  break
                case 'costs':
                  this.import_data_table.costs.push(column)
                  break
                case 'categories':
                  this.import_data_table.categories.push(column)
                  break
                case 'images':
                  this.import_data_table.images.push(column)
                  break
                case 'barcodes':
                  this.import_data_table.barcodes.push(column)
                  break
                case 'instocks':
                  this.import_data_table.instocks.push(column)
                  break
                case 'warehouses':
                  this.import_data_table.warehouses.push(column)
                  break
                case 'units':
                  this.import_data_table.units.push(column)
                  break
                case 'skus':
                  this.import_data_table.skus.push(column)
                  break
              }
            }
          })
        })
      }
    },
    'import_data_table': {
      handler: function () {
        var isValid = this.getImportProductCount > 0
        this.$emit('get-import-products', isValid, this.getImportProducts, this.refBy)

        this.checkIsvalidEachColumn()
      },
      deep: true,
    },
  },
  destroyed: function () {
    this.$emit('get-import-products', false, [], this.refBy)
  },
  methods: {
    formatNumberFloat (value) {
      if (value == null || value == undefined) {
        return null
      }
      if (Number.isNaN(value * 1)) {
        return value
      }
      value = parseFloat(value)
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    },
    validateFile (file) {
      var reg = /(.*?)\.(xlsx)$/

      if (!file.match(reg)) {
        return false
      }

      return true
    },
    handleFileUpload () {
      // check found file
      if (this.$refs.input_file.files.length == 0) {
        return
      } else {
        this.import_file_error = false
        this.import_file_name = this.$refs.input_file.files[0].name
      }

      // check file is valid
      if (!this.validateFile(this.$refs.input_file.files[0].name)) {
        this.import_file_error = true
      } else {
        // success

        this.import_file = this.$refs.input_file.files[0]

        readXlsxFile(this.import_file).then((rows) => {
          rows.map((row, index) => {
            if (index == 0) {
              row.map(column => {
                this.import_data_column.push(column)
              })
            } else {
              this.import_data_rows.push(row)
            }
          })
        })
      }
    },
    handleHeadColumnClick (column_name) {
      this.selected_column_ref = column_name
      this.selected_column_index = ''

      // if(column_name !== 'title' && this.import_data_table[this.getRefBy].length == 0) {
      //
      // }
    },
    closeDropDownTitle () {
      $('.dropdown button.title').dropdown('toggle')
    },
    closeDropDownPrices () {
      $('.dropdown button.prices').dropdown('toggle')
    },
    closeDropDownCosts () {
      $('.dropdown button.costs').dropdown('toggle')
    },
    closeDropDownCategories () {
      $('.dropdown button.categories').dropdown('toggle')
    },
    closeDropDownImages () {
      $('.dropdown button.images').dropdown('toggle')
    },
    closeDropDownBarcodes () {
      $('.dropdown button.barcodes').dropdown('toggle')
    },
    closeDropDownInStocks () {
      $('.dropdown button.instocks').dropdown('toggle')
    },
    closeDropDownWarehouses () {
      $('.dropdown button.warehouses').dropdown('toggle')
    },
    closeDropDownUnits () {
      $('.dropdown button.units').dropdown('toggle')
    },
    closeDropDownSkus () {
      $('.dropdown button.skus').dropdown('toggle')
    },
    isValidName (value) {
      return this.getNames.includes(value)
    },
    isValidBarcode (value) {
      return this.getBarcodes.includes(`${value}`)
    },
    isValidString (value) {
      if (value === undefined || value === null) {
        return false
      }
      return value.toString().trim().length > 0
    },
    isValidSKU(value) {
      return this.allSkuCode.includes(value)
    },
    isValidNumber (value) {
      if (value === undefined) {
        return true
      }
      return !Number.isNaN(value * 1)
    },
    checkIsvalidEachColumn () {
      this.isInvalidNameCount = 0
      this.isInvalidCount = 0
      this.isInvalidTitleCount = 0
      this.isInvalidPriceCount = 0
      this.isInvalidCostCount = 0
      this.isInvalidBarcodeCount = 0
      this.isInvalidSkuCount = 0

      for (const title of this.import_data_table.title) {
        if (!this.isValidString(title)) {
          this.isInvalidCount++
          this.isInvalidTitleCount++
        }
        if (!this.isValidName(title) && this.refBy === 'product_name') {
          this.isInvalidCount++
          this.isInvalidNameCount++
        }
      }

      for (const price of this.import_data_table.prices) {
        if (!this.isValidNumber(price)) {
          this.isInvalidCount++
          this.isInvalidPriceCount++
        }
      }

      for (const cost of this.import_data_table.costs) {
        if (!this.isValidNumber(cost)) {
          this.isInvalidCount++
          this.isInvalidCostCount++
        }
      }

      for (const barcode of this.import_data_table.barcodes) {
        if (!this.isValidBarcode(barcode) && this.refBy === 'barcode') {
          this.isInvalidCount++
          this.isInvalidBarcodeCount++
        }
      }

      for (const sku of this.import_data_table.skus) {
        if (!this.isValidSKU(sku) && this.refBy === 'sku') {
          this.isInvalidCount++
          this.isInvalidSkuCount++
        }
      }

      this.$emit('update:isvalid', this.isInvalidCount === 0)
    },
  },
  async created () {
    await Promise.all([
      this.$store.dispatch('getWarehouses'),
      this.$store.dispatch('getAllSkuCode'),
      this.$store.dispatch('getNames'),
      this.$store.dispatch('getBarcodes'),
    ])

    this.showFinish(this.$Progress)
  },
}
</script>

  <style scoped>
    .table {

    }
    .table thead tr {

    }
    .table thead tr td {
      position: relative;
      padding: 0;
    }
    .table thead tr .fa-hand-point-down {
      position: absolute;
      top: -12px;
      left: 1px;
    }
    .table thead tr td .icon-import {
      position: relative;
    }
    .table thead tr td .dropdown button[data-toggle="dropdown"] {
      width: 100%;
      text-align: left;
      padding: 10px;
    }
    .table thead tr td .dropdown .dropdown-menu {
      top: -1px !important;
      left: -1px !important;
    }
    .table thead tr td .dropdown .dropdown-menu form {
      font-size: 14px;
    }
    .table tbody tr td.not-found {
      color: #ccc;
    }
    .vert-move {
        -webkit-animation: mover 0.5s infinite  alternate;
        animation: mover 0.5s infinite  alternate;
    }
    .vert-move {
        -webkit-animation: mover 0.5s infinite  alternate;
        animation: mover 0.5s infinite  alternate;
    }
    @-webkit-keyframes mover {
        0% { transform: translateY(0); }
        100% { transform: translateY(-10px); }
    }
    @keyframes mover {
        0% { transform: translateY(0); }
        100% { transform: translateY(-10px); }
    }
    .wrapper-table {
      overflow: auto;
      overflow-x: hidden;
      min-height: 150px;
      max-height: 390px;
      padding-top: 12px;
      margin-top: -8px;
    }
    .wrapper-table .btn:disabled {
      opacity: .3;
    }

    .file-cta:focus,
    .file-name:focus,
    .is-focused.file-cta,
    .is-focused.file-name,
    .file-cta:active,
    .file-name:active,
    .is-active.file-cta,
    .is-active.file-name {
      outline: none;
    }
    .file-name[disabled],
    fieldset[disabled] .file-cta,
    fieldset[disabled] .file-name {
      cursor: not-allowed;
    }

  .file {
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    position: relative;
  }

  .file.is-white .file-cta {
    background-color: white;
    border-color: transparent;
    color: #0a0a0a;
  }

  .file.is-white:hover .file-cta, .file.is-white.is-hovered .file-cta {
    background-color: #f9f9f9;
    border-color: transparent;
    color: #0a0a0a;
  }

  .file.is-white:focus .file-cta, .file.is-white.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(255, 255, 255, 0.25);
    color: #0a0a0a;
  }

  .file.is-white:active .file-cta, .file.is-white.is-active .file-cta {
    background-color: #f2f2f2;
    border-color: transparent;
    color: #0a0a0a;
  }

  .file.is-black .file-cta {
    background-color: #0a0a0a;
    border-color: transparent;
    color: white;
  }

  .file.is-black:hover .file-cta, .file.is-black.is-hovered .file-cta {
    background-color: #040404;
    border-color: transparent;
    color: white;
  }

  .file.is-black:focus .file-cta, .file.is-black.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(10, 10, 10, 0.25);
    color: white;
  }

  .file.is-black:active .file-cta, .file.is-black.is-active .file-cta {
    background-color: black;
    border-color: transparent;
    color: white;
  }

  .file.is-light .file-cta {
    background-color: whitesmoke;
    border-color: transparent;
    color: #363636;
  }

  .file.is-light:hover .file-cta, .file.is-light.is-hovered .file-cta {
    background-color: #eeeeee;
    border-color: transparent;
    color: #363636;
  }

  .file.is-light:focus .file-cta, .file.is-light.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(245, 245, 245, 0.25);
    color: #363636;
  }

  .file.is-light:active .file-cta, .file.is-light.is-active .file-cta {
    background-color: #e8e8e8;
    border-color: transparent;
    color: #363636;
  }

  .file.is-dark .file-cta {
    background-color: #363636;
    border-color: transparent;
    color: whitesmoke;
  }

  .file.is-dark:hover .file-cta, .file.is-dark.is-hovered .file-cta {
    background-color: #2f2f2f;
    border-color: transparent;
    color: whitesmoke;
  }

  .file.is-dark:focus .file-cta, .file.is-dark.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(54, 54, 54, 0.25);
    color: whitesmoke;
  }

  .file.is-dark:active .file-cta, .file.is-dark.is-active .file-cta {
    background-color: #292929;
    border-color: transparent;
    color: whitesmoke;
  }

  .file.is-primary .file-cta {
    background-color: #00d1b2;
    border-color: transparent;
    color: #fff;
  }

  .file.is-primary:hover .file-cta, .file.is-primary.is-hovered .file-cta {
    background-color: #00c4a7;
    border-color: transparent;
    color: #fff;
  }

  .file.is-primary:focus .file-cta, .file.is-primary.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(0, 209, 178, 0.25);
    color: #fff;
  }

  .file.is-primary:active .file-cta, .file.is-primary.is-active .file-cta {
    background-color: #00b89c;
    border-color: transparent;
    color: #fff;
  }

  .file.is-link .file-cta {
    background-color: #3273dc;
    border-color: transparent;
    color: #fff;
  }

  .file.is-link:hover .file-cta, .file.is-link.is-hovered .file-cta {
    background-color: #276cda;
    border-color: transparent;
    color: #fff;
  }

  .file.is-link:focus .file-cta, .file.is-link.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(50, 115, 220, 0.25);
    color: #fff;
  }

  .file.is-link:active .file-cta, .file.is-link.is-active .file-cta {
    background-color: #2366d1;
    border-color: transparent;
    color: #fff;
  }

  .file.is-info .file-cta {
    background-color: #209cee;
    border-color: transparent;
    color: #fff;
  }

  .file.is-info:hover .file-cta, .file.is-info.is-hovered .file-cta {
    background-color: #1496ed;
    border-color: transparent;
    color: #fff;
  }

  .file.is-info:focus .file-cta, .file.is-info.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(32, 156, 238, 0.25);
    color: #fff;
  }

  .file.is-info:active .file-cta, .file.is-info.is-active .file-cta {
    background-color: #118fe4;
    border-color: transparent;
    color: #fff;
  }

  .file.is-success .file-cta {
    background-color: #23d160;
    border-color: transparent;
    color: #fff;
  }

  .file.is-success:hover .file-cta, .file.is-success.is-hovered .file-cta {
    background-color: #22c65b;
    border-color: transparent;
    color: #fff;
  }

  .file.is-success:focus .file-cta, .file.is-success.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(35, 209, 96, 0.25);
    color: #fff;
  }

  .file.is-success:active .file-cta, .file.is-success.is-active .file-cta {
    background-color: #20bc56;
    border-color: transparent;
    color: #fff;
  }

  .file.is-warning .file-cta {
    background-color: #ffdd57;
    border-color: transparent;
    color: rgba(0, 0, 0, 0.7);
  }

  .file.is-warning:hover .file-cta, .file.is-warning.is-hovered .file-cta {
    background-color: #ffdb4a;
    border-color: transparent;
    color: rgba(0, 0, 0, 0.7);
  }

  .file.is-warning:focus .file-cta, .file.is-warning.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(255, 221, 87, 0.25);
    color: rgba(0, 0, 0, 0.7);
  }

  .file.is-warning:active .file-cta, .file.is-warning.is-active .file-cta {
    background-color: #ffd83d;
    border-color: transparent;
    color: rgba(0, 0, 0, 0.7);
  }

  .file.is-danger .file-cta {
    background-color: #ff3860;
    border-color: transparent;
    color: #fff;
  }

  .file.is-danger:hover .file-cta, .file.is-danger.is-hovered .file-cta {
    background-color: #ff2b56;
    border-color: transparent;
    color: #fff;
  }

  .file.is-danger:focus .file-cta, .file.is-danger.is-focused .file-cta {
    border-color: transparent;
    box-shadow: 0 0 0.5em rgba(255, 56, 96, 0.25);
    color: #fff;
  }

  .file.is-danger:active .file-cta, .file.is-danger.is-active .file-cta {
    background-color: #ff1f4b;
    border-color: transparent;
    color: #fff;
  }

  .file.is-small {
    font-size: 0.75rem;
  }

  .file.is-medium {
    font-size: 1.25rem;
  }

  .file.is-medium .file-icon .fa {
    font-size: 21px;
  }

  .file.is-large {
    font-size: 1.5rem;
  }

  .file.is-large .file-icon .fa {
    font-size: 28px;
  }

  .file.has-name .file-cta {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .file.has-name .file-name {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  .file.has-name.is-empty .file-cta {
    border-radius: 4px;
  }

  .file.has-name.is-empty .file-name {
    display: none;
  }

  .file.is-boxed .file-label {
    flex-direction: column;
  }

  .file.is-boxed .file-cta {
    flex-direction: column;
    height: auto;
    padding: 1em 3em;
  }

  .file.is-boxed .file-name {
    border-width: 0 1px 1px;
  }

  .file.is-boxed .file-icon {
    height: 1.5em;
    width: 1.5em;
  }

  .file.is-boxed .file-icon .fa {
    font-size: 21px;
  }

  .file.is-boxed.is-small .file-icon .fa {
    font-size: 14px;
  }

  .file.is-boxed.is-medium .file-icon .fa {
    font-size: 28px;
  }

  .file.is-boxed.is-large .file-icon .fa {
    font-size: 35px;
  }

  .file.is-boxed.has-name .file-cta {
    border-radius: 4px 4px 0 0;
  }

  .file.is-boxed.has-name .file-name {
    border-radius: 0 0 4px 4px;
    border-width: 0 1px 1px;
  }

  .file.is-centered {
    justify-content: center;
  }

  .file.is-fullwidth .file-label {
    width: 100%;
  }

  .file.is-fullwidth .file-name {
    flex-grow: 1;
    max-width: none;
  }

  .file.is-right {
    justify-content: flex-end;
  }

  .file.is-right .file-cta {
    border-radius: 0 4px 4px 0;
  }

  .file.is-right .file-name {
    border-radius: 4px 0 0 4px;
    border-width: 1px 0 1px 1px;
    order: -1;
  }

  .file-label {
    align-items: stretch;
    display: flex;
    cursor: pointer;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
  }

  .file-label:hover .file-cta {
    background-color: #eeeeee;
    color: #363636;
  }

  .file-label:hover .file-name {
    border-color: #d5d5d5;
  }

  .file-label:active .file-cta {
    background-color: #e8e8e8;
    color: #363636;
  }

  .file-label:active .file-name {
    border-color: #cfcfcf;
  }

  .file-input {
    height: 100%;
    left: 0;
    opacity: 0;
    outline: none;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .file-cta,
  .file-name {
    border-color: #dbdbdb;
    border-radius: 4px;
    font-size: 1em;
    padding-left: 1em;
    padding-right: 1em;
    white-space: nowrap;
  }

  .file-cta {
    background-color: whitesmoke;
    color: #4a4a4a;
  }

  .file-name {
    border-color: #dbdbdb;
    border-style: solid;
    border-width: 1px 1px 1px 0;
    display: block;
    max-width: 16em;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
  }

  .file-icon {
    align-items: center;
    display: flex;
    height: 1em;
    justify-content: center;
    margin-right: 0.5em;
    width: 1em;
  }

  .file-icon .fa {
    font-size: 14px;
  }
  .file {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .file-cta, .file-name {
    -moz-appearance: none;
    -webkit-appearance: none;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: none;
    display: inline-flex;
    font-size: 1rem;
    height: 30px;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    border-color: #dbdbdb;
    font-size: 14px;
  }
  .file-name {
    border-left: none;
  }
  .is-invalid {
    background-color: var(--danger);
  }

  tbody tr td {
    position: relative;
  }

  tbody tr td .con-vs-tooltip {
    display: none;
  }

  tbody tr td.is-invalid .con-vs-tooltip {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/custom/ImportProductsUpdate.vue